var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('topnav',{staticClass:"w-100",staticStyle:{"position":"fixed","z-index":"999","top":"0"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }